import type {
	GetResourcesQueryParams,
	GetResourceThemesQueryParams,
} from "@dune/types";

export const resourcesQueryKeys = {
	all: ["resources"] as const,
	lists: () => [...resourcesQueryKeys.all, "lists"] as const,
	list: (params?: GetResourcesQueryParams) =>
		[...resourcesQueryKeys.lists(), params] as const,
	themes: (params?: GetResourceThemesQueryParams) =>
		[...resourcesQueryKeys.all, "themes", params] as const,
};
